<template>
    <v-data-table :headers="headers" :items="listItems">
        <template v-slot:[`item.actions`]="{ item }">
            <v-tooltip color="transparent" bottom>
                <template v-slot:activator="{ on }">
                    <span class="mr-2 p-0 cog" v-on="on">
                        <v-icon>mdi-information</v-icon>
                    </span>
                </template>
                <v-data-table
                    style="box-shadow: 0 0 2px 1px grey"
                    :headers="headersTooltip"
                    :items="getTooltipItems(item)"
                    hide-default-footer
                ></v-data-table>
            </v-tooltip>
            <v-tooltip bottom v-if="item.subscriptionKey">
                <template v-slot:activator="{ on, attrs }">
                    <span
                        class="mr-2 p-0 circle cog"
                        @click="moduleAPIsettings(item)"
                        v-bind="attrs"
                        v-on="on"
                    >
                        <img
                            src="/images/_SVGs/bo/cog-outline.svg"
                            onload="SVGInject(this)"
                            width="20"
                            height="20"
                        />
                    </span>
                </template>
                <span>{{
                    $t(
                        "backoffice.modules-management.vrm.components.datatable-list.access-data"
                    )
                }}</span>
            </v-tooltip>
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <span
                        class="mr-2 p-0 circle"
                        @click="moduleEdit(item)"
                        v-bind="attrs"
                        v-on="on"
                    >
                        <img
                            src="/images/_SVGs/bo/edit_pencil.svg"
                            onload="SVGInject(this)"
                            width="20"
                            height="20"
                        />
                    </span>
                </template>
                <span>{{
                    $t(
                        "backoffice.modules-management.vrm.components.datatable-list.edit-access"
                    )
                }}</span>
            </v-tooltip>
        </template>

        <template v-slot:[`item.isActive`]="{ item }">
            <v-chip
                :color="getColor(item.isActive)"
                pill
                dark
                small
                class="status-column"
            >
                {{ getTextState(item.isActive) }}
            </v-chip>
        </template>

        <template v-slot:[`item.lastUsedDate`]="{ item }">
          {{item.lastUsedDate | formatDate}}
        </template>
    </v-data-table>
</template>

<script>
export default {
    props: {
        listItems: null,
        roleId: null,
        moduleName: String,
    },
    data() {
        return {
            headersTooltip: [
                {
                    text: this.$t("backoffice.vrm.table.datasource"),
                    align: "start",
                    filterable: false,
                    value: "name",
                },
                {
                    text: this.$t("backoffice.vrm.table.pack-type"),
                    align: "start",
                    filterable: false,
                    value: "type",
                },
                {
                    text: this.$t("backoffice.vrm.table.balance"),
                    align: "start",
                    filterable: false,
                    value: "value",
                },
            ],
            headers: [
                {
                    text: this.$t(
                        "backoffice.modules-management.vrm.components.datatable-list.headers.customer"
                    ),
                    align: "start",
                    value: "entityParent",
                    class: "header-table-color",
                },
                {
                    text: this.$t(
                        "backoffice.modules-management.vrm.components.datatable-list.headers.user"
                    ),
                    value: "fullName",
                    class: "header-table-color",
                },
                {
                    text: this.$t(
                        "backoffice.modules-management.vrm.components.datatable-list.headers.module"
                    ),
                    value: "vrmAccessTipology",
                    class: "header-table-color",
                },
                {
                    text: this.$t('last-use'),
                    value: "lastUsedDate",
                    align: "center",
                    class: "header-table-color",
                },
                {
                    text: this.$t(
                        "backoffice.modules-management.vrm.components.datatable-list.headers.status"
                    ),
                    value: "isActive",
                    align: "center",
                    class: "header-table-color",
                },
                {
                    text: this.$t(
                        "backoffice.modules-management.vrm.components.datatable-list.headers.obs"
                    ),
                    value: "observations",
                    align: "center",
                    class: "header-table-color",
                },
                {
                    text: "",
                    value: "actions",
                    sortable: false,
                    align: "right",
                    class: "header-table-color",
                },
            ],
        };
    },
    methods: {
        getTooltipItems(item) {
            let arr = [];
            arr = arr.concat(
                item.userPackTotalBalance.map((o) => ({
                    ...o,
                    type: this.$t("backoffice.vrm.normal-pack"),
                })),
                item.entityPackTotalBalance.map((o) => ({
                    ...o,
                    type: this.$t("backoffice.vrm.reserve-pack"),
                }))
            );
            return arr;
        },
        moduleEdit(item) {
            this.$router.push({
                name: "backoffice-users-modules-vrm-config-access",
                params: {
                    id: this.$route.params.id,
                    vrm_access_id: item.vrmAccessId,
                    moduleName: this.moduleName,
                },
            });
        },
        getColor(status) {
            if (status == true) return "green";
            else if (status == false) return "red";
            else return "orange";
        },
        getTextState(status) {
            if (status == true)
                return this.$t("backoffice.general.active-status");
            else if (status == false)
                return this.$t("backoffice.general.inactive-status");
            else
                return this.$t(
                    "backoffice.modules-management.vrm.components.datatable-list.no-status"
                );
        },
        moduleAPIsettings(item) {
            this.$emit("show-api-settings", item);
        },
    },
};
</script>

<style lang="scss">
@import "@sass/_variables.scss";
#content-backoffice {
    table {
        thead {
            tr {
                th {
                    border: 0;
                    
                    &.header-table-color {
                        background-color: #f2f2f2 !important;
                        color: #9e9d9d !important;
                        font-weight: 500;
                    }
                }
            }
        }
        tbody {
            tr {
                td {
                    font-size: 12px;
                    border: 0;
                }
            }
        }
    }
    .status-column {
        width: 100%;
        margin: 0 auto;
        text-align: center;
        .v-chip__content {
            margin: 0 auto;
            text-align: center;
            font-size: 12px;
        }
    }
    .row-services {
        width: 85px;
        margin: 0 auto;
        @media (max-width: 599px) {
            display: block !important;
        }
        .service {
            @media (max-width: 599px) {
                float: left;
            }
        }
        .services {
            height: 14px !important;
            width: 14px !important;
            border-radius: 50% !important;
            font-size: 12px !important;
            padding: 2px;
        }
    }

    .circle {
        background-color: #e6e5e5;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        display: -webkit-inline-box;
        cursor: pointer;
    }

    .cog {
        svg {
            path {
                fill: #666666 !important;
            }
        }
    }
}
</style>
